import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
import { InactivityService } from 'src/app/services/inactivity.service';
import { NotificacionesService } from 'src/app/services/notificaciones.service';
import { UtilsService } from 'src/app/services/utils.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html'
})
export class FooterComponent implements OnInit {
  nombreSistema: String = environment.ENVIRONMENT.NOMBRE_SISTEMA;
  ambienteSistema: String = environment.ENVIRONMENT.AMBIENTE;
  versionSistema: String = environment.ENVIRONMENT.VERSION;

  form: FormGroup;
  idleTimerLeft: string;
  secondTimerLeft: string;
  timeRemain: number;
  FULL_DASH_ARRAY = 283;
  currentYear = new Date().getFullYear();

  constructor(private inactivityService: InactivityService, private formService: FormService, private utilsService: UtilsService, private alert: NotificacionesService) { }

  ngOnInit(): void {
    this.form = this.formService.getInactivityForm(environment.ENVIRONMENT.INACTIVITY_MINUTES);
    this.initTimer(this.form.value.firstLevelTimer);
  }

  formatTimeLeft = (time: number) => {
    if (time > 0) {
      let seconds = Math.trunc(time / 1000);
      //this.setCircleDasharray(seconds);
      let min = 0;
      if (seconds >= 60) {
        min = Math.trunc(seconds / 60);
        seconds -= (min * 60);
      }
      return `${min}:${seconds}`;
    }
  }

  setCircleDasharray = (elapsedTime: number) => {
    const inputValue: any = this.form.value;
    const timeLimit = inputValue.firstLevelTimer * 60;
    this.timeRemain = elapsedTime / timeLimit;
    const circleDasharray = `${(
      this.timeRemain * this.FULL_DASH_ARRAY
    ).toFixed(0)} 283`;
    document.getElementById('base-timer-path-remaining').setAttribute('stroke-dasharray', circleDasharray);
  }

  initTimer(firstTimerValue: number): void {
    this.inactivityService.USER_IDLE_TIMER_VALUE_IN_MIN = firstTimerValue;
    this.inactivityService.initilizeSessionTimeout();
    this.inactivityService.userIdlenessChecker.subscribe((status: string) => {
      this.initiateFirstTimer(status);
    });
  }

  initiateFirstTimer = (status: string) => {
    switch (status) {
      case 'INITIATE_TIMER':
      case 'RESET_TIMER':
        break;
      case 'STOPPED_TIMER':
        this.cerrarSesion();
        break;
      default:
        this.idleTimerLeft = this.formatTimeLeft(Number(status));
        // console.log('idleTimerLeft', this.idleTimerLeft);
        break;
    }
  }

  cerrarSesion(): void {
    InactivityService.runTimer = false;
    this.alert.info('Se ha cerrado su sesión por inactividad', true);
    this.utilsService.redirectLogin();
  }

}
